import { LanguageCode } from '../model/resource/language';

export const DEFAULT_LANGUAGE_CODE = LanguageCode.Russian;
